<template>
  <tr :class="{active: checked, 'is-disabled': blocked, clickable: !blocked}"
      @click="onRowClick">
    <td @click.stop>
      <label class="form-checkbox tooltip tooltip-right" :data-tooltip="selectTooltip">
        <input type="checkbox" :checked="checked" :disabled="blocked"
               @change="$emit('toggle', item)">
        <i class="form-icon"></i>
      </label>
    </td>
    <td class="num">{{ item.startDate | date }}</td>
    <td>
      <span class="cr-type" :class="`cr-type-${item.type}`">{{ guideTypeName(item.type) }}</span>
    </td>
    <td>
      <span class="text-bold num">{{ guideNumber(item) || '—' }}</span>
      <span class="sub">{{ operatorLabel }}</span>
      <span class="sub text-warning" v-if="warning">{{ warning }}</span>
    </td>
    <td>
      <span class="text-bold">{{ item.patient ? item.patient.name : '—' }}</span>
      <span class="sub" v-if="insured.record">
        Carteirinha {{ insured.record }}
        <template v-if="insured.validity">
          · <span :class="{'text-error': recordExpired}">
            {{ recordExpired ? 'vencida em' : 'válida até' }} {{ insured.validity | date }}
          </span>
        </template>
      </span>
      <span class="sub" v-else>Sem carteirinha</span>
    </td>
    <td class="hide-sm" v-if="!compact">{{ item.professional ? item.professional.name : '—' }}</td>
    <td class="text-right hide-sm">{{ item.itemsCount }}</td>
    <td class="text-right text-bold num">{{ informed | currency }}</td>
    <td class="actions-cell">
      <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
              data-tooltip="Abrir guia"
              @click.stop="$emit('open', item)">
        <fa-icon :icon="['fal', 'eye']"/>
      </button>
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import { guideTypeName, guideNumber, passwordExpiringLabel } from '../service';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabledReason: {
      type: String,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    blocked() {
      return !!this.disabledReason;
    },
    selectTooltip() {
      return this.disabledReason || 'Selecionar para o lote';
    },
    insured() {
      return (this.item.insurance && this.item.insurance.insured) || {};
    },
    informed() {
      return (this.item.totals && this.item.totals.informed) || 0;
    },
    recordExpired() {
      return !!this.insured.validity
        && moment(this.insured.validity).isBefore(moment(this.item.startDate), 'day');
    },
    operatorLabel() {
      const operator = this.item.referral && this.item.referral.insurance;
      const password = this.item.authorization && this.item.authorization.password;
      const parts = [operator ? `Operadora ${operator}` : 'Operadora —'];
      if (password) parts.push(`senha ${password}`);
      else if (this.item.type === 'sadt') parts.push('sem senha');
      return parts.join(' · ');
    },
    warning() {
      return passwordExpiringLabel(this.item);
    },
  },
  methods: {
    guideTypeName,
    guideNumber,
    onRowClick() {
      if (this.blocked) return;
      this.$emit('toggle', this.item);
    },
  },
};
</script>
